@if (breadcrumbs?.length>0) {
  <div class="breadcrumbs">
    <span matTooltip="Doublc click path to copy" [dblClickCopy]="breadcrumbs[0]">{{breadcrumbs[0]}}</span>
    @if (breadcrumbs.length>1) {
      <div class="alt">
        <i [matMenuTriggerFor]="menu" class="fas fa-list-alt" matTooltip="Alternate paths"></i>
        <mat-menu #menu="matMenu" class="breadcrumbs-menu">
          @for (bc of breadcrumbs | slice:1; track $index) {
            <div matTooltip="Doublc click path to copy"
            [dblClickCopy]="bc">{{bc}}</div>
          }
        </mat-menu>
      </div>
    }
    <i (click)="breadcrumbs=[]" class="fa fa-times" matTooltip="Hide"></i>
  </div>
}
